// router.js
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

let router = new Router({
  base: '/',
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/index.vue"),
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/index.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/login.vue"),
    },
    {
      path: "/collect",
      name: "collect",
      component: () => import("@/views/collect/collect.vue"),
    },
    {
      path: "/personal",
      name: "personal",
      component: () => import("@/views/personal/index.vue"),
    },
    {
      path: "*", // 重定向页面地址
      redirect: "/",
    },
  ],
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
})

export default router;
